<script setup lang="ts">
/**
 * ФИО в ячейке: «Фамилия И.О.», полное имя с бэка в тултипе.
 * Обёртка как в CollapsibleCell: VTooltip + activator + open-delay 200.
 */
import type { IPersonName } from '@/utils/formatters'
import { formatShortName, getPersonDisplayName } from '@/utils/formatters'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<{
  person?: IPersonName | string | null
  emptyText?: string
}>(), {
  emptyText: '',
})

const attrs = useAttrs()

const fullName = computed(() => getPersonDisplayName(props.person))
const shortName = computed(() => formatShortName(props.person))
const showTooltip = computed(() => Boolean(fullName.value && shortName.value))
</script>

<template>
  <VTooltip
    v-if="showTooltip"
    location="top"
    open-delay="200"
  >
    <template #activator="{ props: tooltipProps }">
      <span v-bind="{ ...tooltipProps, ...attrs }">
        {{ shortName }}
      </span>
    </template>
    <span>{{ fullName }}</span>
  </VTooltip>
  <span
    v-else
    v-bind="attrs"
  >{{ emptyText }}</span>
</template>
